import arr from './arr-stats'
import sampleMeta from '../refs/sampleMeta'

import trackDetails from '../refs/trackDetails'
import categoryTracks from '../refs/categoryTracks'
import sampleMetaPCC from '../refs/sampleMetaPCC'
import trackDetailsPCC from '../refs/trackDetailsPCC'
import categoryTracksPCC from '../refs/categoryTracksPCC'
import cloneDeep from 'lodash/cloneDeep'



let sampleMetaDict = {'PTRC': sampleMeta, 'PCC': sampleMetaPCC}
let trackDetailsDict = {'PTRC': trackDetails, 'PCC': trackDetailsPCC}
let categoryTracksDict = {'PTRC': categoryTracks, 'PCC': categoryTracksPCC}

let SampleDashboard_stratifyVar = {'PTRC': {'VarName': 'response',
                                            'class1': 'R', 'class2': 'NR',
                                          'class1_name': 'Response', 'class2_name': 'Non-response'},
                                  'PCC': {'VarName': 'tissue_level',
                                          'class1': 'Primary', 'class2': 'Metastasis',
                                          'class1_name': 'Primary', 'class2_name': 'Metastasis'}
                                  }

export const transform_k_track_v_data = (k_track_v_data, study = 'PTRC') => {
    let samples = Object.keys(sampleMetaDict[study])
    const sampleMetaTransformed = transformSampleMeta(sampleMetaDict[study])
    let res = sampleMetaTransformed
    Object.entries(k_track_v_data).forEach(([track, data]) => {
        if (track.includes('mut')) { return }
        const gene = track.split(' ')[0]
        // const dataType = track.split(' ')[1]
        const dataType = ''
        const raw_z_tumor = samples
            .map(sample => k_track_v_data[track][`${sample}-T`])
        const raw_z_normal = samples
            .map(sample => k_track_v_data[track][`${sample}-N`])
        const raw_z = [...raw_z_tumor, ...raw_z_normal]
            .filter(el => el && !(typeof el === 'string'))
        const z_scores = arr.zScores(raw_z)
        const zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
        const tumorKey = `${track} T`
        const normalKey = `${track} N`
        let tumorData = createTissueObj({
            trackObj: k_track_v_data[track], 
            tissueStr: '-T',
            zScoreDict,
        })
        let normalData = createTissueObj({
            trackObj: k_track_v_data[track], 
            tissueStr: '-N',
            zScoreDict,
        })
        res[tumorKey] = {
            title: tumorKey,
            data: tumorData,
            clinical: false,
            clinicalData: null,
            omics: gene,
            dataType,
            // tissue: 'tumor',
            label: 'AR-DX',
            parent: track,
        }
        res[normalKey] = {
            title: normalKey,
            data: normalData,
            clinical: false,
            clinicalData: null,
            omics: gene,
            dataType,
            // tissue: 'normal',
            label: 'Non AR-DX',
            parent: track,
        }
    })
    
    return res
}


function createTissueObj({
    trackObj,
    tissueStr,
    zScoreDict,
  }) {
    return Object.fromEntries(Object.keys(trackObj)
      .filter(sample => sample.includes(tissueStr))
      .map(sample => [
          sample.split(tissueStr)[0], 
          zScoreDict[trackObj[sample]]
        ]
      )
    )
  }

function createScatterObj({
    trackObj,
    // tissueStr,
    zScoreDict,
  }) {
    return Object.fromEntries(Object.keys(trackObj)
      .map(sample => [
          sample, 
          zScoreDict[trackObj[sample]]
        ]
      )
    )
  }

function createDXObj({
    trackObj,
    dxStr,
    zScoreDict,
  }) {
    return Object.fromEntries(Object.keys(trackObj)
      .filter(sample => sample.includes(dxStr))
      .map(sample => [
          sample.split(dxStr)[0], 
          zScoreDict[trackObj[sample]]
        ]
      )
    )
  }

function createTrackCategory(categoryTracks_) {
    let trackCategory = {}
    Object.entries(categoryTracks_).forEach(([category, trackList]) => {
        trackList.forEach((track) => trackCategory[track] = category)
    })
    return trackCategory
}

function createDataObj({
    trackObj,
    cohortArray,
    zScoreDict,
  }) {
    return Object.fromEntries(Object.keys(trackObj)
      .filter(sample => cohortArray.includes(sample))
      .map(sample => [sample, zScoreDict[trackObj[sample]]]
      )
    )
}

function renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map(key => {
        const newKey = newKeys[key] || key;
        return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
}

export const transformSampleMeta = (sampleMeta_, study_) => {
    let res = {}
    let trackCategory = createTrackCategory(categoryTracksDict[study_])
    Object.entries(sampleMeta_).forEach(([sample, meta]) => {
    Object.entries(meta).forEach(([track, val]) => {
        if (!(track in res)) { res[track] = {
            title: track,
            data: {},
            clinical: true,
            clinicalData: {
                trackDetails: trackDetailsDict[study_][track],
                group: trackCategory[track],
                numerical: trackCategory[track] === 'Numerical',
                show: true,
            },
            omics: null,
            dataType: null,
            label: null,
        } }
        res[track].data[sample] = val
    })
    })
    return res
}


// export const combine_k_track_v_data_NOT_normalized = (k_track_v_data) => {
//     const sampleMetaTransformed = transformSampleMeta()
//     let res = sampleMetaTransformed
//     Object.entries(k_track_v_data).forEach(([track, data]) => {
//         if (track.includes('mut')) { return }
//         const gene = track.split(' ')[0]
//         // const dataType = track.split(' ')[1]
//         const dataType = ''
//         console.log('testcombineraw')
//         const tumorKey = `${track} T`
//         const normalKey = `${track} N`

//         let tumorData = Object.fromEntries(Object.entries(k_track_v_data[track])
//             .filter(([sample, v]) => sample.includes('-T'))
//             .map(([sample, v]) => [sample.split('-T')[0], v]))

//         let normalData = Object.fromEntries(Object.entries(k_track_v_data[track])
//             .filter(([sample, v]) => sample.includes('-N'))
//             .map(([sample, v]) => [sample.split('-N')[0], v]))

//         res[tumorKey] = {
//             title: tumorKey,
//             data: tumorData,
//             clinical: false,
//             clinicalData: null,
//             omics: gene,
//             dataType,
//             label: 'AR-DX',
//             parent: track,
//         }
//         res[normalKey] = {
//             title: normalKey,
//             data: normalData,
//             clinical: false,
//             clinicalData: null,
//             omics: gene,
//             dataType,
//             label: 'Non AR-DX',
//             parent: track,
//         }
//     })
    
//     return res
// }

export const transform_k_track_v_data_noTN_zbool = ({k_track_v_data, z_bool, combine_bool, studySelected}) => {
    const sampleMetaTransformed = transformSampleMeta(sampleMetaDict[studySelected], studySelected)
    let res = sampleMetaTransformed
    
    // console.log('transform_k_track_v_data_noTN_zbool res start', res)    
    let response_val_array = res[SampleDashboard_stratifyVar[studySelected].VarName].data
    // console.log('transform_k_track_v_data_noTN_zbool response_array', response_val_array) 
    // const keysWithR = Object.keys(dictionary).filter(key => dictionary[key] === 'R');
    let response_cohort = Object.keys(response_val_array).filter(
                                key => response_val_array[key] === SampleDashboard_stratifyVar[studySelected].class1);
    let non_response_cohort = Object.keys(response_val_array).filter(
                                key => response_val_array[key] === SampleDashboard_stratifyVar[studySelected].class2);
    let whole_cohort = Object.keys(response_val_array)
    console.log('transform_k_track_v_data_noTN_zbool response_cohort', response_cohort) 


    Object.entries(k_track_v_data).forEach(([track, data]) => {
        if (track.includes('mut')) { return }
        const dataType = track.split(' ')[1]
        var gene = ''
        if (dataType === 'CellType') {
            gene = track.split(' ')[0]
        } else if (track.startsWith('5S_rRNA_ENSG')) {
            gene = track.split(' ')[0]
        } else {
            gene = track.split(' ')[0].split('_')[0]
        }
        // const dataType = track.split(' ')[1]
        // const dataType = ''
        // console.log('testcombineraw')
        const responseKey = `${track} (${SampleDashboard_stratifyVar[studySelected].class1})`
        const nonResponseKey = `${track} (${SampleDashboard_stratifyVar[studySelected].class2})`

        const responseDataArray = response_cohort
            .map(sample => k_track_v_data[track][sample])
        const nonresponseDataArray = non_response_cohort
            .map(sample => k_track_v_data[track][sample])
        const raw_z = [...responseDataArray, ...nonresponseDataArray]
            .filter(el => el && !(typeof el === 'string'))
        const z_scores = arr.zScores(raw_z)
        let zScoreDict = null
        let wholeDict = null
        if (z_bool){
            zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
            // wholeDict = z_scores
        } else {
            zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, raw_z[i]]))
        }

        let responseData = createDataObj({
            trackObj: k_track_v_data[track], 
            cohortArray: response_cohort,
            zScoreDict,
        })
        let nonResponseData = createDataObj({
            trackObj: k_track_v_data[track], 
            cohortArray: non_response_cohort,
            zScoreDict,
        })
        let wholeCohortData = createDataObj({
            trackObj: k_track_v_data[track], 
            cohortArray: whole_cohort,
            zScoreDict,
        })

        let responseDataDict = {
            title: responseKey,
            data: responseData,
            clinical: false,
            clinicalData: null,
            omics: 'gene',
            gene: gene,
            dataType,
            label: SampleDashboard_stratifyVar[studySelected].class1_name,
            parent: track,
        }
        let nonResponseDataDict = {
            title: nonResponseKey,
            data: nonResponseData,
            clinical: false,
            clinicalData: null,
            omics: 'gene',
            gene: gene,
            dataType,
            label: SampleDashboard_stratifyVar[studySelected].class2_name,
            parent: track,
        }

        if (combine_bool) {
            res[track] = {
                title: track,
                data: wholeCohortData,
                clinical: false,
                clinicalData: null,
                omics: 'gene',
                gene: gene,
                dataType,
                label: 'Whole cohort',
                parent: track,
                responseCohort: responseDataDict,
                nonResponseCohort: nonResponseDataDict
            }
        } else {
            res[responseKey] = responseDataDict
            res[nonResponseKey] = nonResponseDataDict
        }
        
    })
    console.log('transform_k_track_v_data_noTN_zbool res final', res)
    return res
}

export const transform_k_track_v_data_noTN_zbool2 = ({k_track_v_data, z_bool, 
                                                    combine_bool, studySelected,
                                                    stratifyVarName = 'default',
                                                }) => {
    const sampleMetaTransformed = transformSampleMeta(sampleMetaDict[studySelected], studySelected)
    let res = sampleMetaTransformed
    
    // console.log('transform_k_track_v_data_noTN_zbool res start', res)
    var stratifyVarName_ = stratifyVarName
    
    if (stratifyVarName === 'default') {
        stratifyVarName_ = SampleDashboard_stratifyVar[studySelected].VarName
    }
    
    var defaultStratifyVar = SampleDashboard_stratifyVar[studySelected].VarName
    console.log('transform_k_track_v_data_noTN_zbool stratifyVarName_', stratifyVarName_)
    let response_val_array = res[stratifyVarName_].data
    // console.log('transform_k_track_v_data_noTN_zbool response_array', response_val_array) 
    // const keysWithR = Object.keys(dictionary).filter(key => dictionary[key] === 'R');
    let response_cohort = Object.keys(response_val_array).filter(
                                key => response_val_array[key] === SampleDashboard_stratifyVar[studySelected].class1);
    let non_response_cohort = Object.keys(response_val_array).filter(
                                key => response_val_array[key] === SampleDashboard_stratifyVar[studySelected].class2);
    let whole_cohort = Object.keys(response_val_array)
    // console.log('transform_k_track_v_data_noTN_zbool response_cohort', response_cohort) 

    var categoriesFromVar = trackDetailsDict[studySelected][stratifyVarName_]
    console.log(trackDetailsDict[studySelected])
    console.log('transform_k_track_v_data_noTN_zbool categoriesFromVar', categoriesFromVar)
    Object.entries(k_track_v_data).forEach(([track, data]) => {
         if (track.includes('mut')) { return }
        const dataType = track.split(' ')[1]
        var gene = ''
        if (dataType === 'CellType') {
            gene = track.split(' ')[0]
        } else if (track.startsWith('5S_rRNA_ENSG')) {
            gene = track.split(' ')[0]
        } else {
            gene = track.split(' ')[0].split('_')[0]
        }
        var raw_z = []
        var catVarCohortDict = {}
        var catDataArrayDict = {}
        Object.entries(categoriesFromVar).forEach(([idx, catData]) => {
            
            let catKeyName = catData.label
            if (checkInput(catKeyName)) { return }
            let catVarCohort = Object.keys(response_val_array).filter(
                                    key => response_val_array[key] === catData.label);
            
            const catKey = `${track} (${catData.label})`
            const catDataArray = catVarCohort
                .map(sample => k_track_v_data[track][sample])
            
            raw_z.push(catDataArray)
            catVarCohortDict[catKeyName] = catVarCohort
            catDataArrayDict[catKeyName] = catDataArray
            
        })
        raw_z = raw_z.flat()
        
        raw_z = raw_z.filter(el => Number.isFinite(el) && !(typeof el === 'string'))
        // const raw_z = [...responseDataArray, ...nonresponseDataArray]
            
        const z_scores = arr.zScores(raw_z)
        let zScoreDict = null
        let wholeDict = null
        if (z_bool){

            zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
            console.log('helper js', track, zScoreDict, z_scores)
            // wholeDict = z_scores
        } else {
            zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, raw_z[i]]))
        }
        console.log('transform_k_track_v_data_noTN_zbool zScoreDict', raw_z, zScoreDict)
        if (combine_bool) {

            const responseKey = `${track} (${SampleDashboard_stratifyVar[studySelected].class1})`
            const nonResponseKey = `${track} (${SampleDashboard_stratifyVar[studySelected].class2})`
            let wholeCohortData = createDataObj({
                            trackObj: k_track_v_data[track], 
                            cohortArray: whole_cohort,
                            zScoreDict,
                        })
            
            let responseData = createDataObj({
                trackObj: k_track_v_data[track], 
                cohortArray: response_cohort,
                zScoreDict,
            })
            let nonResponseData = createDataObj({
                trackObj: k_track_v_data[track], 
                cohortArray: non_response_cohort,
                zScoreDict,
            })
            let responseDataDict = {
                title: responseKey,
                data: responseData,
                clinical: false,
                clinicalData: null,
                omics: 'gene',
                gene: gene,
                dataType,
                label: SampleDashboard_stratifyVar[studySelected].class1_name,
                parent: track,
            }
            let nonResponseDataDict = {
                title: nonResponseKey,
                data: nonResponseData,
                clinical: false,
                clinicalData: null,
                omics: 'gene',
                gene: gene,
                dataType,
                label: SampleDashboard_stratifyVar[studySelected].class2_name,
                parent: track,
            }
                        
            res[track] = {
                title: track,
                data: wholeCohortData,
                clinical: false,
                clinicalData: null,
                omics: 'gene',
                gene: gene,
                dataType,
                label: 'Whole cohort',
                parent: track,
                responseCohort: responseDataDict,
                nonResponseCohort: nonResponseDataDict
            }
        } else {
            Object.entries(categoriesFromVar).forEach(([idx, catData2]) => {
                let catKey = catData2.label
                console.log('transform_k_track_v_data_noTN_zbool catKey', catKey)
                if (checkInput(catKey)) { return }
                const trackCatKey = `${track} (${catData2.label})`
                console.log('transform_k_track_v_data_noTN_zbool catKey', catVarCohortDict[catKey])
                
                let catDataObj = createDataObj({
                    trackObj: k_track_v_data[track], 
                    cohortArray: catVarCohortDict[catKey],
                    zScoreDict,
                })
                let catDataDict = {
                    title: catKey,
                    data: catDataObj,
                    clinical: false,
                    clinicalData: null,
                    omics: 'gene',
                    gene: gene,
                    dataType,
                    label: stratifyVarName_,
                    parent: track,
                }
                res[trackCatKey] = catDataDict
            })
        }
        
    })
    console.log('transform_k_track_v_data_noTN_zbool res final', res)
    return res
}

export const transform_1_track_v_data = (k_track_v_data, z_bool) => {
    let samples = Object.keys(sampleMeta)
    const sampleMetaTransformed = transformSampleMeta()
    let res = sampleMetaTransformed
    // res[k_track_v_data.keys[0]] = 
    Object.entries(k_track_v_data).forEach(([track, data]) => {
        if (track.includes('mut')) { return }
        // console.log('test scatter 5')
        console.log(track)
        console.log(data)
        const gene = track.split(' ')[0]
        // const dataType = track.split(' ')[1]
        const dataType = ''
        const raw_z_tumor = samples
            .map(sample => k_track_v_data[track][`${sample}-T`])
        const raw_z_normal = samples
            .map(sample => k_track_v_data[track][`${sample}-N`])
        const raw_z = [...raw_z_tumor, ...raw_z_normal]
            .filter(el => el && !(typeof el === 'string'))
        const z_scores = arr.zScores(raw_z)
        let zScoreDict = null
        let wholeDict = null
        if (z_bool){
            zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
            // wholeDict = z_scores
        } else {
            zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, raw_z[i]]))
        }
        
        const tumorKey = `${track} T`
        const normalKey = `${track} N`
        let tumorData = createTissueObj({
            trackObj: k_track_v_data[track], 
            tissueStr: '-T',
            zScoreDict,
        })
        let normalData = createTissueObj({
            trackObj: k_track_v_data[track], 
            tissueStr: '-N',
            zScoreDict,
        })

        let wholeData = {...tumorData, ...normalData}
        res[tumorKey] = {
            title: tumorKey,
            data: tumorData,
            clinical: false,
            clinicalData: null,
            omics: gene,
            dataType,
            // tissue: 'tumor',
            label: 'AR-DX',
            parent: track,
        }
        res[normalKey] = {
            title: normalKey,
            data: normalData,
            clinical: false,
            clinicalData: null,
            gene,
            dataType,
            // tissue: 'normal',
            label: 'Non AR-DX',
            parent: track,
        }
        res[track] = {
            title: track,
            data: wholeData,
            clinical: false,
            clinicalData: null,
            gene,
            dataType,
            // tissue: 'normal',
            label: 'All patients',
            parent: track,
        }

    })
    
    return res
}

export const transform_heatmap_track_v_data = (k_track_v_data, z_bool) => {
    let samples = Object.keys(sampleMetaDict['PTRC'])
    const sampleMetaTransformed = transformSampleMeta()
    let res = sampleMetaTransformed
    // res[k_track_v_data.keys[0]] = 
    Object.entries(k_track_v_data).forEach(([track, data]) => {
        if (track.includes('mut')) { return }
        console.log('test heatmap 100')
        console.log(track)
        console.log(data)
        const gene = track.split(' ')[0]
        // const dataType = track.split(' ')[1]
        const dataType = ''

        var new_samples_name = {}
        let raw_zkeys = Object.keys(data)
        // console.log
        // console.log('test heatmap10')
        // console.log(raw_zkeys)
        
        const raw_z_tumor = samples
            .map(sample => k_track_v_data[track][`${sample}-T`])
        const raw_z_normal = samples
            .map(sample => k_track_v_data[track][`${sample}-N`])
        const raw_z = [...raw_z_tumor, ...raw_z_normal]
            .filter(el => el && !(typeof el === 'string'))
        const z_scores = arr.zScores(raw_z)
        let zScoreDict = null
        let wholeDict = null
        if (z_bool){
            zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
            // wholeDict = z_scores
        } else {
            zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, raw_z[i]]))
        }
        
        const tumorKey = `${track} T`
        const normalKey = `${track} N`
        let tumorData = createTissueObj({
            trackObj: k_track_v_data[track], 
            tissueStr: '-T',
            zScoreDict,
        })
        let normalData = createTissueObj({
            trackObj: k_track_v_data[track], 
            tissueStr: '-N',
            zScoreDict,
        })

        let wholeData = {...tumorData, ...normalData}
        var renamed_track = renameKeys(wholeData, new_samples_name)
        // let raw_z = samples.map(sample => renamed_track[sample])
        // const z_scores = arr.zScores(raw_z)
        // var zScoreDict;
        // if (z_bool){
        //     zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
        //     // wholeDict = z_scores
        // } else {
        //     zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, raw_z[i]]))
        // }
        // var renamed_track = renameKeys(cloneDeep(k_track_v_data[track]), new_samples_name)

        console.log('heatmap z')
        console.log(z_scores)
        // console.log('test heatmap11')
        // console.log(new_samples_name)
        // console.log('test heatmap13')
        // console.log(renamed_track)


        // let wholeData = createScatterObj({
        //     trackObj: k_track_v_data[track],
        // })

        res[track] = {
            title: track,
            data: renamed_track,
            clinical: false,
            clinicalData: null,
            gene,
            dataType,
            // tissue: 'normal',
            label: track,
            parent: track,
        }
        console.log('heatmap 14')
        console.log(res)

    })
    
    return res
}

export const cartesianProduct = (arr) => {
    return arr.reduce(function(a,b){
        return a.map(function(x){
            return b.map(function(y){
                return x.concat([y]);
            })
        }).reduce(function(a,b){ return a.concat(b) },[])
    }, [[]])
}



// export const combine_1_track_v_data_NOT_normalized = (k_track_v_data) => {
//     let samples = Object.keys(sampleMeta)
//     const sampleMetaTransformed = transformSampleMeta()
//     let res = sampleMetaTransformed
//     Object.entries(k_track_v_data).forEach(([track, data]) => {
//         if (track.includes('mut')) { return }
//         const gene = track.split(' ')[0]
//         // const dataType = track.split(' ')[1]
//         const dataType = ''

//         const tumorKey = `${track} T`
//         const normalKey = `${track} N`

//         // let tumorData = Object.fromEntries(Object.entries(k_track_v_data[track])
//         //     .filter(([sample, v]) => sample.includes('-T'))
//         //     .map(([sample, v]) => [sample.split('-T')[0], v]))

//         // let normalData = Object.fromEntries(Object.entries(k_track_v_data[track])
//         //     .filter(([sample, v]) => sample.includes('-N'))
//         //     .map(([sample, v]) => [sample.split('-N')[0], v]))

//         const raw_z_tumor = samples
//             .map(sample => k_track_v_data[track][`${sample}-T`])
//         const raw_z_normal = samples
//             .map(sample => k_track_v_data[track][`${sample}-N`])
//         const raw_z = [...raw_z_tumor, ...raw_z_normal]
//             .filter(el => el && !(typeof el === 'string'))

//         res[tumorKey] = {
//             title: tumorKey,
//             data: tumorData,
//             clinical: false,
//             clinicalData: null,
//             gene,
//             dataType,
//             label: 'AR-DX',
//             parent: track,
//         }
//         res[normalKey] = {
//             title: normalKey,
//             data: normalData,
//             clinical: false,
//             clinicalData: null,
//             gene,
//             dataType,
//             label: 'Non AR-DX',
//             parent: track,
//         }
//     })
    
//     return res
// }

function checkInput(variable) {
  if (
    variable === null ||         // Checks for null
    Number.isNaN(variable) ||    // Checks for NaN
    variable === ""    ||
    variable === "NaN"           // Checks for empty string
    // Optional additional checks:
    // variable === undefined || // Checks for undefined
    // (typeof variable === 'string' && variable.trim() === '') // Checks for whitespace only
  ) {
    console.log(`The value '${variable}' is empty or invalid.`);
    return true;
  }
  console.log(`The value '${variable}' is valid.`);
  return false;
}